<template>
    <component :is="currentIcon" />
</template>

<script setup lang="ts">
    import IconAuthorization from './Icons/IconAuthorization.vue';
    import IconHome from './Icons/IconHome.vue';

    const props = defineProps<{
        iconName: string;
    }>();

    const icons: Record<string, ReturnType<typeof defineComponent>> = {
        IconAuthorization,
        IconHome
    };

    const currentIcon = computed(() => {
        return icons[props.iconName];
    });
</script>
